import React, { useState, useEffect, useRef } from "react";
import Header from "../../components/Header";
import FooterLanding from "../../components/FooterLanding";
import CenteredColumnLayout from "../../components/CenteredColumnLayout";
import RowColLayout from "../../components/RowColLayout";
import LiquidContainer from "../../components/LiquidContainer";
import FormField from "../../components/FormField";
import MyButton from "../../components/MyButton";
import liftPass from "../../assets/images/logos/lift_pass.png";
import liftpassicon from "../../assets/icons/small_icons/liftpassblue.png";
import SnowBackground from "../../components/SnowBackground";
import { liftpassGet, liftpassPost, liftPassNumPost, liftPassNumGet } from "../../api/user";

const LiftPass = () => {
  const [inputValue, setInputValue] = useState("");
  const [imageSrc, setImageSrc] = useState(null);
  const [hasLiftPass, setHasLiftPass] = useState(false);

  useEffect(() => {
    loadImage();
    loadLiftPassNumber();
  }, []);

  const fileInputRef = useRef(null);

  const openFileDialog = () => {
    fileInputRef.current.click();
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!inputValue) {
    alert("Please enter your lift pass number");
    return;
  }

  try {
    await liftPassNumPost({
      lift_pass_number: inputValue
    });

    alert("Lift pass number saved successfully");
  } catch (error) {
    console.error(error);
    alert("Ha ocurrido un error");
  }
};

const loadLiftPassNumber = async () => {
  try {
    const response = await liftPassNumGet(); // GET request
    const number = response.lift_pass_number;

    if (number) {
      setInputValue(number);
      setHasLiftPass(true);
    }

  } catch (error) {
    console.log("No lift pass number yet");
  }
};

const handleUpload = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  try {
    await liftpassPost(file);
    alert("Uploaded successfully");

    // reload image after upload
    handleDownload();
  } catch (error) {
    console.error(error);
    alert("Upload failed");
  }
};


//DO NOT REMOVE THIS COMMENT
// const handleDownload = async () => {
//   console.log("HandleDownload in front")
//   try {
//     const blob = await liftpassGet();
//     const imageUrl = URL.createObjectURL(blob);
//     setImageSrc(imageUrl);
//   } catch (error) {
//     console.log("No lift photo yet");
//   }
// };

const handleDownload = async () => {
  try {
    const blob = await liftpassGet();


    const imageUrl = URL.createObjectURL(blob);
    setImageSrc(imageUrl);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "liftpass.png"; // filename
    document.body.appendChild(a);
    a.click();

    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.log("No lift photo yet");
  }
};

const loadImage = async () => {
  try {
    const blob = await liftpassGet();
    const imageUrl = URL.createObjectURL(blob);
    setImageSrc(imageUrl);
  } catch (error) {
    console.log("No lift photo yet");
  }
};

  return (
    <div className="vh-100 d-flex flex-column position-relative" style={{overflowY: "scroll"}}>

      {/* Blurred Background Layer */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: "url('/static/images/backLogin.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          filter: "blur(8px)",      // 👈 blur amount
          transform: "scale(1.1)",  // 👈 prevents white edges after blur
          zIndex: -1,
        }}
      />

      <Header />
      <SnowBackground />

      <div className="flex-grow-1 d-flex flex-column justify-content-evenly">
        
        <CenteredColumnLayout>
          <img
            src={liftPass}
            alt="Lift Pass"
            style={{
              height: "auto",
              width: "auto",
              backgroundColor: "#f5fdff64",
              borderRadius: "25px",
              transform: "rotate(35deg)"
            }}
          />
        </CenteredColumnLayout>

        <CenteredColumnLayout>
          <LiquidContainer>
            <div className="liftpassform w-100 m-0 px-4 py-4">
              <form
                onSubmit={handleSubmit}
                className="d-flex flex-column justify-content-center align-items-center"
              >
                <FormField
                  label="Número de Lift Pass"
                  name="liftpass"
                  type="text"
                  placeholder="Número de Lift Pass"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  hasError={false}
                  icon={liftpassicon}
                />

                <div
                  className="d-flex justify-content-center align-items-center mt-4"
                  style={{ width: "70%" }}
                >
                  <MyButton text="GUARDAR" type="submit" disabled={hasLiftPass} />
                </div>
              </form>
            </div>
          </LiquidContainer>
        </CenteredColumnLayout>


    <CenteredColumnLayout>
        <div className="upload download">
          <input
            ref={fileInputRef}
            type="file"
            accept="image/jpeg,image/png,image/webp"
            onChange={handleUpload}
            className="my-1"
            style={{ display: "none" }}
          />
        </div>
        <div>
          {imageSrc ? (
            <MyButton text="DESCARGAR FOTO" onClick={handleDownload} />
            ):(
              <MyButton text="SUBIR FOTO" onClick={openFileDialog} />
            )}
        </div>
    </CenteredColumnLayout>
        {/* <div>
          {imageSrc && (
            <img
              src={imageSrc}
              alt="Lift Pass"
              style={{ marginTop: "20px", maxWidth: "200px" }}
            />
          )}
        </div> */}
      </div>

      <FooterLanding className="mt-auto" />
    </div>
  );
};


export default LiftPass;
